import _debounce from "lodash.debounce";
import { PATHS } from "./paths";
import { ReactComponent as Category1 } from "../assets/gallery/category-1.svg";
import { ReactComponent as Category2 } from "../assets/gallery/category-2.svg";
import { ReactComponent as Category3 } from "../assets/gallery/category-3.svg";
import { ReactComponent as Category4 } from "../assets/gallery/category-4.svg";
import { ReactComponent as Category5 } from "../assets/gallery/category-5.svg";
import { ReactComponent as Category6 } from "../assets/gallery/category-6.svg";

import background1 from "../assets/dashboard/lesson-background.svg";
import icon1 from "../assets/dashboard/lesson-icon.svg";
import { ReactComponent as Layout1 } from "../assets/layout/layout-main-page.svg";
import { ReactComponent as Layout2 } from "../assets/layout/layout-conversation.svg";
import { ReactComponent as Layout3 } from "../assets/layout/layout-leaders.svg";
import { ReactComponent as Layout4 } from "../assets/layout/layout-flow.svg";
import { ReactComponent as Layout5 } from "../assets/layout/layout-profile.svg";
import { ReactComponent as Layout1Active } from "../assets/layout/layout-main-page-active.svg";
import { ReactComponent as Layout2Active } from "../assets/layout/layout-conversation-active.svg";
import { ReactComponent as Layout3Active } from "../assets/layout/layout-leaders-active.svg";
import { ReactComponent as Layout4Active } from "../assets/layout/layout-flow-active.svg";
import { ReactComponent as Layout5Active } from "../assets/layout/layout-profile-active.svg";

import debounce from "lodash.debounce";

export const debouncedSearch = (onChange) => _debounce(onChange, 500);

// Kept in lockstep with the app-wide nav breakpoint (sidebar/ContentBlock/
// MobileMenu all switch at 768) — at exactly 768px chat previously had
// neither sidebar nor its own burger bar.
export const CHAT_MOBILE_BREAKPOINT = 768;

export const CHAT_FILTER_OPTIONS = (t) => [
  {
    key: "all",
    label: t("ALL"),
  },
  {
    key: "groups",
    label: t("GROUPS"),
  },
];

export const isEditableDate = (createdDate) => {
  const now = new Date();
  const dateCreated = new Date(createdDate);
  const diffInHours = (now - dateCreated) / (1000 * 60 * 60);
  return diffInHours <= 24;
};

export const categorys = [
  { id: 1, title: "Ծրագրավորում", icon: Category1 },
  { id: 2, title: "Տվյալների վերլուծություն", icon: Category2 },
  { id: 3, title: "Արդուինո", icon: Category3 },
  { id: 4, title: "3D Մոդելավորում", icon: Category4 },
  { id: 5, title: "Ռոբոտաշինություն", icon: Category5 },
  { id: 6, title: "Ճարտարագիտական հիմունքներ", icon: Category6 },
];

export const dashboardLessons = (t) => [
  {
    id: 1,
    background: background1,
    icon: icon1,
    rate: 4.5,
    status: t("BEGINNER"),
    lessonCount: 43,
    lessonPass: 17,
    title: "Python-ի հիմունքներ",
    lesson: "28 Դաս",
    time: "4ժ 10ր",
    students: "2.1K+ Միածաց ուսանողներ",
    description:
      "Python ծրագրավորման դասsfghjjjgtcdhxjh hgfcd ujgcdjdcj jugcdըն....",
  },
  {
    id: 2,
    background: background1,
    icon: icon1,
    rate: 4.5,
    status: t("BEGINNER"),
    lessonCount: 43,
    lessonPass: 17,
    title: "Python-ի հիմունքներ",
    lesson: "28 Դաս",
    time: "4ժ 10ր",
    students: "2.1K+ Միածաց ուսանողներ",
    description:
      "Python ծրագրավորման դասsfghjjjgtcdhxjh hgfcd ujgcdjdcj jugcdըն....",
  },
  {
    id: 3,
    background: background1,
    icon: icon1,
    rate: 4.5,
    status: t("BEGINNER"),
    lessonCount: 43,
    lessonPass: 17,
    title: "Python-ի հիմունքներ",
    lesson: "28 Դաս",
    time: "4ժ 10ր",
    students: "2.1K+ Միածաց ուսանողներ",
    description:
      "Python ծրագրավորման դասsfghjjjgtcdhxjh hgfcd ujgcdjdcj jugcdըն....",
  },
  {
    id: 4,
    background: background1,
    icon: icon1,
    rate: 4.5,
    status: t("BEGINNER"),
    lessonCount: 43,
    lessonPass: 17,
    title: "Python-ի հիմունքներ",
    lesson: "28 Դաս",
    time: "4ժ 10ր",
    students: "2.1K+ Միածաց ուսանողներ",
    description:
      "Python ծրագրավորման դասsfghjjjgtcdhxjh hgfcd ujgcdjdcj jugcdըն....",
  },
  {
    id: 5,
    background: background1,
    icon: icon1,
    rate: 4.5,
    status: t("BEGINNER"),
    lessonCount: 43,
    lessonPass: 17,
    title: "Python-ի հիմունքներ",
    lesson: "28 Դաս",
    time: "4ժ 10ր",
    students: "2.1K+ Միածաց ուսանողներ",
    description:
      "Python ծրագրավորման դասsfghjjjgtcdhxjh hgfcd ujgcdjdcj jugcdըն....",
  },
  {
    id: 6,
    background: background1,
    icon: icon1,
    rate: 4.5,
    status: t("BEGINNER"),
    lessonCount: 43,
    lessonPass: 17,
    title: "Python-ի հիմունքներ",
    lesson: "28 Դաս",
    time: "4ժ 10ր",
    students: "2.1K+ Միածաց ուսանողներ",
    description:
      "Python ծրագրավորման դասsfghjjjgtcdhxjh hgfcd ujgcdjdcj jugcdըն....",
  },
  {
    id: 7,
    background: background1,
    icon: icon1,
    rate: 4.5,
    status: t("BEGINNER"),
    lessonCount: 43,
    lessonPass: 17,
    title: "Python-ի հիմունքներ",
    lesson: "28 Դաս",
    time: "4ժ 10ր",
    students: "2.1K+ Միածաց ուսանողներ",
    description:
      "Python ծրագրավորման դասsfghjjjgtcdhxjh hgfcd ujgcdjdcj jugcdըն....",
  },
  {
    id: 8,
    background: background1,
    icon: icon1,
    rate: 4.5,
    status: t("BEGINNER"),
    lessonCount: 43,
    lessonPass: 17,
    title: "Python-ի հիմունքներ",
    lesson: "28 Դաս",
    time: "4ժ 10ր",
    students: "2.1K+ Միածաց ուսանողներ",
    description:
      "Python ծրագրավորման դասsfghjjjgtcdhxjh hgfcd ujgcdjdcj jugcdըն....",
  },
];

export const dashBoardMenuItems = (t) => [
  { key: "points", label: t("POINTS") },
  { key: "streak", label: t("STREAK") },
  { key: "accuracy", label: t("ACCURACY") },
];

export const leadersData = {
  points: {
    local: null,
    global: 10,
    friends: 10,
  },
  streak: {
    local: null,
    global: 3,
    friends: 1,
  },
  accuracy: {
    local: null,
    global: 25,
    friends: 7,
  },
};

// Every navigation target resolves to a real Route (see appRoute/AppRoute.js).
// Drive paths from PATHS so navigation and routing cannot drift apart.
export const MenuItems = (t) => [
  {
    id: 1,
    path: PATHS.Learn, // the Learn dashboard (post-login landing page)
    title: t("MAIN_PAGE"),
    icon: Layout1,
    activeIcon: Layout1Active,
  },
  {
    id: 2,
    path: PATHS.Conversations,
    title: t("CONVERSATIONS"),
    icon: Layout2,
    activeIcon: Layout2Active,
  },
  {
    id: 3,
    path: PATHS.Leaderboard, // dedicated leaderboard page (Figma 2261-5049)
    title: t("LEADERS"),
    icon: Layout3,
    activeIcon: Layout3Active,
  },
  {
    id: 4,
    path: PATHS.Feed,
    title: t("FEED"),
    icon: Layout4,
    activeIcon: Layout4Active,
  },
  {
    id: 5,
    path: PATHS.Profile,
    title: t("PROFILE"),
    icon: Layout5,
    activeIcon: Layout5Active,
  },
];

/**
 * Creates a debounced function with cancel support
 * @param {Function} fn
 * @param {number} delay
 */
export const createDebounce = (fn, delay = 300) => {
  const debouncedFn = debounce(fn, delay);

  return {
    run: debouncedFn,
    cancel: debouncedFn.cancel,
    flush: debouncedFn.flush,
  };
};

export const getSlidesToShow = () => {
  const width = window.innerWidth;

  if (width < 1000) return 1.2;
  if (width < 1400) return 2.5;
  if (width < 1700) return 3.5;
  return 4.5;
};

export const FILTERS = (t) => [
  { key: "all", label: t("ALL") },
  { key: "recommended", label: t("RECOMMENDED") },
  { key: "news", label: t("NEWS") },
  { key: "trending", label: t("TRENDING") },
];

export const categoriesFilter = [
  {
    id: 1,
    title: "Ոլորտներ",
    hiddenOptions: ["Դիզայն", "Python", "JS", "React", "Angular"],
  },
  {
    id: 2,
    title: "Դասընթացի մաակրդակը",
    hiddenOptions: ["Սկսնակ", "Միջին", "Փորձառու", "Դիզայն", "Python"],
  },
  {
    id: 3,
    title: "Դասընթացի մաակրդակը",
    hiddenOptions: ["Հաճախ օգտագործվո", "Python"],
  },
];

export const levelsData = [
  {
    id: 1,
    name: "1",
    title: "Բաժին 1: Հիմունքներ",
    completed: true,
  },
  {
    id: 2,
    name: "2",
    title: "Բաժին 2: Ներմուծում",
    completed: true,
  },
  {
    id: 3,
    name: "3",
    title: "Բաժին 3: Տվյալների տեսակներ",
    completed: true,
  },
  {
    id: 4,
    name: "4",
    title: "",
    completed: false,
  },
  {
    id: 5,
    name: "5",
    title: "Բաժին 5: Կլասներ",
    completed: false,
  },
  {
    id: 6,
    name: "6",
    title: "Բաժին 6: Մոդուլներ",
    completed: false,
  },
  {
    id: 7,
    name: "7",
    title: "Բաժին 7: Ֆայլերի աշխատանք",
    completed: false,
  },
  {
    id: 8,
    name: "8",
    title: "Բաժին 8: Տվյալների վերլուծություն",
    completed: false,
  },
  {
    id: 9,
    name: "9",
    title: "Բաժին 9: Գրաֆիկներ",
    completed: false,
  },
  {
    id: 10,
    name: "10",
    title: "Բաժին 10: Դասընթացի ամփոփում",
    completed: false,
  },
];

export const LANGUAGES = [
  {
    label: "Web (HTML/CSS/JS)",
    value: "web",
    text: "",
  },

  {
    label: "JavaScript",
    value: "javascript",
    text: `// JavaScript example\nconsole.log("Hello, World!");\n`,
  },

  {
    label: "Python",
    value: "python",
    text: `# Python example\nprint("Hello, World!")\n`,
  },
  { label: "Bash", value: "bash", text: `#!/bin/bash\necho "Hello, World!"\n` },
  {
    label: "Java",
    value: "java",
    text: `// Java example\npublic class Main {\n    public static void main(String[] args) {\n        System.out.println("Hello, World!");\n    }\n}\n`,
  },
  {
    label: "C",
    value: "C",
    text: `// C example\n#include <stdio.h>\n\nint main() {\n    printf("Hello, World!");\n    return 0;\n}\n`,
  },
  {
    label: "C++",
    value: "cpp",
    text: `// C++ example\n#include <iostream>\n\nint main() {\n    std::cout << "Hello, World!";\n    return 0;\n}\n`,
  },
  {
    label: "Kotlin",
    value: "kotlin",
    text: `// Kotlin example\nfun main() {\n    println("Hello, World!")\n}\n`,
  },
  {
    label: "Ruby",
    value: "ruby",
    text: `# Ruby example\nputs "Hello, World!"\n`,
  },
  {
    label: "PHP",
    value: "php",
    text: `<?php\n// PHP example\necho "Hello, World!";\n`,
  },
  {
    label: "Swift",
    value: "swift",
    text: `// Swift example\nimport Foundation\n\nprint("Hello, World!")\n`,
  },
  {
    label: "Go",
    value: "go",
    text: `// Go example\npackage main\n\nimport "fmt"\n\nfunc main() {\n    fmt.Println("Hello, World!")\n}\n`,
  },
  {
    label: "Rust",
    value: "rust",
    text: `// Rust example\nfn main() {\n    println!("Hello, World!");\n}\n`,
  },
];

export const languageModeMap = {
  javascript: "javascript",
  typescript: "typescript",
  html: "html",
  css: "css",
  kotlin: "kotlin",
  swift: "swift",
  text: "text",
  python: "python",
  java: "java",
  go: "golang",
  ruby: "ruby",
  php: "php",
  rust: "rust",
  c: "c_cpp",
  cpp: "c_cpp",
  bash: "sh",
};

export function formatDateTimeArmenian(dateTimeStr) {
  const date = new Date(dateTimeStr);

  if (isNaN(date)) return "";

  const hour = date.getHours();
  const minute = date.getMinutes();

  return ` ${hour}ժ ${minute}ր`;
}

export const needsInput = (code, lang) => {
  // Normalize code: remove comments & strings to reduce false positives (optional but recommended)
  // For simplicity we skip heavy parsing here — string.includes() is usually good enough for playgrounds

  const lowerCode = code.toLowerCase(); // case-insensitive matching

  switch (
    lang.toLowerCase() // normalize lang value just in case
  ) {
    // ────────────────────────────────────────
    // Already good
    case "python":
      return lowerCode.includes("input(");

    // ────────────────────────────────────────
    // C family – most common input functions
    case "c":
      return (
        lowerCode.includes("scanf(") ||
        lowerCode.includes("gets(") || // deprecated but still seen
        lowerCode.includes("fgets(") ||
        lowerCode.includes("getchar(")
      );

    case "cpp": // C++
      return (
        lowerCode.includes("std::cin") || // most common
        lowerCode.includes("cin >>") ||
        lowerCode.includes("getline(") || // std::getline(std::cin, ...)
        lowerCode.includes("scanf(")
      );

    // ────────────────────────────────────────
    // Java – Scanner is by far the most common in educational code
    case "java":
      return (
        lowerCode.includes("scanner") || // usually: new Scanner(System.in)
        lowerCode.includes(".next") || // next(), nextInt(), nextLine()...
        lowerCode.includes("system.console") // rare but possible
      );

    // ────────────────────────────────────────
    // Kotlin – usually uses readLine() or readln()
    case "kotlin":
      return (
        lowerCode.includes("readline(") ||
        lowerCode.includes("readln(") ||
        lowerCode.includes("scanner")
      );

    // ────────────────────────────────────────
    // Ruby – almost always gets / readline
    case "ruby":
      return (
        lowerCode.includes("gets") ||
        lowerCode.includes("$stdin") ||
        lowerCode.includes("readline")
      );

    // ────────────────────────────────────────
    // PHP – many ways, but these are most common
    case "php":
      return (
        lowerCode.includes("readline(") ||
        lowerCode.includes("fgets(stdin") ||
        lowerCode.includes("$input = trim(fgets(stdin)") ||
        lowerCode.includes("fopen('php://stdin'")
      );

    // ────────────────────────────────────────
    // Swift – readLine() is standard
    case "swift":
      return lowerCode.includes("readline(");

    // ────────────────────────────────────────
    // Go – bufio / fmt.Scan* family
    case "go":
      return (
        lowerCode.includes("fmt.scan") || // Scan, Scanln, Scanf
        lowerCode.includes("bufio.newreader(os.stdin)") ||
        lowerCode.includes(".readstring") ||
        lowerCode.includes("scanner.scan")
      );

    // ────────────────────────────────────────
    // Rust – std::io::stdin() is canonical
    case "rust":
      return (
        lowerCode.includes("stdin()") ||
        lowerCode.includes("read_line") ||
        lowerCode.includes("std::io")
      );

    // ────────────────────────────────────────
    // Bash / shell – read is the main command
    case "bash":
      return lowerCode.includes("read ");

    // JavaScript – usually not blocking stdin in playgrounds,
    // but if someone uses process.stdin → we can detect it
    case "javascript":
      return (
        lowerCode.includes("process.stdin") ||
        lowerCode.includes("readline") || // node readline module
        lowerCode.includes(".question") // rl.question(...)
      );

    default:
      // Unknown language → assume no interactive input needed
      return false;
  }
};
